import React, { Component } from 'react'
import TweetLayout from '../components/TweetLayout'
import resume from '../resume.json'

export default class experience extends Component {
  render() {
    return (
      <>
        <TweetLayout experience={resume.experience[1]}/>
        <TweetLayout experience={resume.experience[0]}/>
      </>
    )
  }
}
